import { useMediaQuery } from './useMediaQuery';

export function useIsTabletVertical() {
	return {
		isTabletVertical: useMediaQuery([{ width: [['max', 'xl']], orientation: 'portrait' }]),
	};
}
